<div class="form-group mb-3">
     <input #filterBox type="text" class="form-control" [placeholder]="this.getPlaceHolderTemplate()" (keyup)="filter($event,filterBox.value)" (paste)="onPaste($event)" />
</div>

<div class="app-loading" *ngIf="this.loading">
    <app-loading/>
</div>

<div *ngIf="!this.loading">
    <span><b> Number of items displayed: {{ this.items.length }}</b> </span>
    <br>
    <span class="advise-text">The maximum retention period of the individual request is 30 calendar day from the start of the request. After this period the request is removed from the list</span>
</div>

<div class="scroll-container items-table" *ngIf="!this.loading" style="overflow-x: auto;">
    <table class="table table-striped table-hover table-sm">
        <thead style="position: sticky;top: 0;">
            <tr>
                <th style="cursor: pointer;overflow: hidden; text-overflow: ellipsis;white-space: nowrap;"></th>
                <th *ngFor="let column of this.columns;let i = index" 
                style="cursor: pointer;overflow: hidden; text-overflow: ellipsis;white-space: nowrap"
                storageKey="'itemsTable:'{{column.getSourceName()}}"
                appResizableColumn
                ><a (click)="sortBy(column)" style="cursor: pointer" >{{ column.getHeader() }} {{ sortIcon(column.getSourceName()) }}</a></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of items" 
                [ngClass]="{ 
                        'queued-row': item.isQueued, 
                        'inProgress-row': item.isInProgress, 
                        'archived-row': item.isArchived,
                        'errorOrInterrupted-row': item.isErrorOrInterrupted,
                        'canceled-row': item.isCanceled }">
                
                <!-- Actions column -->
                <td class="td-radio" style="white-space: nowrap; overflow: visible;text-align: center;">
                    <input type="radio"
                           name="selectedItem"
                           [value]="item"
                           [(ngModel)]="this.bulkSection.selectedItem"
                    />
                </td>
                <td *ngFor="let column of this.columns" style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;">
                    {{ this.displayValue(item, column) }}
                </td>
            </tr>
            <tr *ngIf="items.length==0">
                <td [attr.colspan]="getColumnsLength()" class="text-center py-5">
                    There are no items for current filter
                </td>
            </tr>
        </tbody>
    </table>
</div>